import "../../assets/Common.scss";
import "../../assets/fonts/font.css";
import React, { useEffect, useRef } from "react";
import chipsWebApi from "../../js/chips-web-api";
import { chipsAppCode } from "../../js/chips-common";

export default function KakaoLoginCallBack(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  const endPoint = window.location.origin;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // KAKAO
  const kakaoClientId = "e70756f39b9983141207090ae7dac505";
  const kakaoRestAPIId = "0e3f31cdadfa5b10e2581a24bb6a647f";
  const kakaoRedirectUri = `${endPoint}/user/kakao/callback`; //Redirect URI
  const integrityValue =
    "sha384-kDljxUXHaJ9xAb2AzRd59KxjrFjzHa5TAoFQ6GbYTCAG0bjM55XohjjDT7tDDC01";
  const kakaoSdkUrl = "https://t1.kakaocdn.net/kakao_js_sdk/2.7.1/kakao.min.js";
  const kakaoAuthCode = urlParams.get("code");

  const initialized = useRef(false);

  useEffect(() => {
    try {
      if (!initialized.current) {
        initialized.current = true;
        if (kakaoAuthCode === null) {
          goBack();
          return;
        }
        const script = document.createElement("script");
        script.src = `${kakaoSdkUrl}`;
        script.integrity = integrityValue;
        script.crossOrigin = "anonymous";
        script.onload = () => {
          // eslint-disable-next-line no-undef
          Kakao.init(kakaoClientId);
          getKakaoToken();
        };
        script.async = true;
        document.body.appendChild(script);
      }
    } catch (e) {
      goBack();
    }
  }, []);

  function goBack() {
    window.location.href = `${endPoint}/user/login`;
  }

  function getChipsToken(accessToken, refreshToken) {
    chipsWebApi.request({
      method: "post",
      url: `${domain}/api/v2/sign/socials`,
      headers: {
        "x-nbt-app-code": chipsAppCode,
        "x-nbt-social-provider": "kakao",
        "x-nbt-social-access-token": accessToken,
        "x-nbt-social-refresh-token": refreshToken,
      },
      data: {},
      then: (response) => {
        const accessToken = response.headers["x-nbt-access-token"] || "";
        const refreshToken = response.headers["x-nbt-refresh-token"] || "";
        if (accessToken !== "" && refreshToken !== "") {
          window.location.href = `${endPoint}/user/withdraw?accessToken=${accessToken}&refreshToken=${refreshToken}`;
        } else {
          alert("카카오 로그인에 실패하였습니다.");
        }
      },
      error: (e, _) => {
        goBack();
      },
    });
  }

  function getKakaoToken() {
    const body = {
      grant_type: "authorization_code",
      client_id: kakaoRestAPIId,
      redirect_uri: kakaoRedirectUri,
      code: kakaoAuthCode,
    };

    chipsWebApi.request({
      method: "post",
      url: `https://kauth.kakao.com/oauth/token`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      },
      data: body,
      then: (response) => {
        const accessToken = response.data.access_token;
        const refreshToken = response.data.refresh_token;

        if (accessToken !== null && refreshToken !== null) {
          getChipsToken(accessToken, refreshToken);
        } else {
          alert("칩스 로그인에 실패하였습니다.");
          goBack();
        }
      },
      catch: (error, _) => {
        goBack();
      },
    });
  }
  return <div></div>;
}
